<template>
  <div id="app-private" class="d-flex min-vh-100">
    <router-view name="sidebar" />
    <div id="app-view" class="d-flex flex-1 flex-column">
      <router-view name="header" />
      <breadcrumbs />
      <div id="app-content" class="flex-1" :class="{ fullWidth: isFullWidth }">
        <router-view />
      </div>
      <router-view name="footer" />
    </div>
  </div>
</template>

<style lang="scss">
  @import './../styles/private';
</style>

<script>
import Breadcrumbs from '@/components/Breadcrumbs';
import { mapState } from 'vuex';

export default {
  name: 'Layout_Private',
  components: {
    Breadcrumbs,
  },
  computed: {
    ...mapState('ui', ['isFullWidth']),
  },
};
</script>
